import React from 'react';
import PropTypes from 'prop-types'

/**
 * Application CSS/SCSS files.
 */
import '../../styles/themes/baseTheme.scss';
import './app.scss';

/**
 * Application JS files.
 */
import 'foundation-sites/dist/js/foundation.js';

/**
 * The App component.
 *
 * @param {{}} props
 * @returns {{}}
 * @constructor
 */
const App = (props) => {
  return (
    <div className="app-wrapper">
      {props.children}
    </div>
  );
};

App.propTypes = {
  children: PropTypes.element,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.js